import cuid from "cuid";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import View from "./View";

const Create = () => {
  const navigate = useNavigate();
  const id = useMemo(() => cuid(), []);
  const cancel = () => navigate(SCREENS.PRIVATE.BROKER.CONTRACTS.LIST.path);
  const [addContract] = useMutation(graphql.mutations.CREATE_CONTRACT, {
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.BROKER.CONTRACTS.LIST.path);
    },
    onError: () => {},
  });
  const onSubmit = ({ author, ...values }) => {
    return addContract({
      variables: {
        data: {
          id,
          identifier: cuid(),
          author: { id: author },
          ...values,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} id={id} cancel={cancel} />;
};

export default Create;
